export const T_Errors = {
  ERROR: {
    EN_US: "An unexpected error occurred.",
    FR_FR: "Une erreur inattendue est survenue.",
  },
  ERROR_REQUIRED: {
    EN_US: "This field must not be empty.",
    FR_FR: "Ce champ ne doit pas être vide.",
  },
  ERROR_REQUIRED_SELECTION: {
    EN_US: "A selection is required to continue.",
    FR_FR: "Une sélection est requise pour poursuivre.",
  },
  ERROR_INVALID_EMAIL: {
    EN_US: "This value is not a valid email address.",
    FR_FR: "Cette valeur n'est pas une adresse e-mail valide.",
  },
  ERROR_INVALID_PHONE: {
    EN_US: "This value is not a valid phone number.",
    FR_FR: "Cette valeur n'est pas un numéro de téléphone valide.",
  },
  ERROR_INVALID_IMAGE: {
    EN_US: "This file is not a valid image.",
    FR_FR: "Ce fichier n'est pas une image valide.",
  },
  ERROR_INVALID_FILE: {
    EN_US: "This file is not valid.",
    FR_FR: "Ce fichier n'est pas valide.",
  },
  ERROR_INSOLE_MODEL_IN_USE: {
    EN_US: "This model is used by existing insoles and cannot be deleted.",
    FR_FR: "Ce modèle est utilisé par des semelles existantes et ne peut pas être supprimé.",
  },
  ERROR_ZONE_PRESET_NAME_TAKEN: {
    EN_US: "A type with this name already exists.",
    FR_FR: "Un type existe déjà avec ce nom.",
  },
  ERROR_TOO_LONG_VALUE: {
    EN_US: "This value exceeds the maximum allowed length.",
    FR_FR: "Cette valeur dépasse la longueur maximale autorisée.",
  },
  ERROR_INVALID_LINK: {
    EN_US: "The link is not valid.",
    FR_FR: "Le lien n’est pas valide.",
  },
  ERROR_RECAPTCHA_INVALID: {
    EN_US: "Invalid Captcha",
    FR_FR: "Captcha invalide.",
  },
  ERROR_ALREADY_SUBMITTED_PROJECT: {
    EN_US: "This project has already been submitted.",
    FR_FR: "Ce projet a déjà été soumis.",
  },
  ERROR_USER_EMAIL_NOT_FOUND: {
    EN_US: "No user found with this email address.",
    FR_FR: "Aucun utilisateur trouvé avec cette adresse e-mail.",
  },
  ERROR_INVALID_EMAIL_OR_PASSWORD: {
    EN_US: "Invalid email address or password.",
    FR_FR: "Adresse e-mail ou mot de passe invalide.",
  },
  ERROR_SHORT_PASSWORD: {
    EN_US: "The password must be at least 6 characters long.",
    FR_FR: "Le mot de passe doit comporter au moins 6 caractères.",
  },
  ERROR_EQUAL_REPEAT_PASSWORD: {
    EN_US: "This value should be equal to the password.",
    FR_FR: "Cette valeur doit être égale au mot de passe.",
  },
  ERROR_EMAIL_ALREADY_EXISTS: {
    EN_US: "A user with this email address already exists.",
    FR_FR: "Un utilisateur avec cette adresse e-mail existe déjà.",
  },
};
